import { action } from "typesafe-actions";

import { IDate } from "../../components/Table/hooks/useDateFilter";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { uploadFile } from "../../helpers";
import { INotices } from "./notices.types";

export const FETCH_NOTICES_LIST_PROGRESS = "FETCH_NOTICES_LIST_PROGRESS";
export const FETCH_NOTICES_LIST_SUCCESS = "FETCH_NOTICES_LIST_SUCCESS";
export const FETCH_NOTICES_LIST_FAILED = "FETCH_NOTICES_LIST_FAILED";

export const fetchNoticesListProgress = () =>
  action(FETCH_NOTICES_LIST_PROGRESS);
export const fetchNoticesListSuccess = (
  list: INotices[],
  totalRecords: number
) => action(FETCH_NOTICES_LIST_SUCCESS, { list, totalRecords });
export const fetchNoticesListFailed = () => action(FETCH_NOTICES_LIST_FAILED);

export const fetchNoticesListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status: string,
    date: IDate,
    searchValue: string,
    searchType: string[]
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchNoticesListProgress());
      let url = "";
      if (status !== "-1") {
        url = "&status=" + status;
      }

      let finalUrl = `/other/get-notice?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}${url}`;

      if (searchType.length > 0 && searchValue) {
        finalUrl = `/other/get-notice?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&column=${[
          searchType,
        ]}&value=${searchValue}`;
      }
      const res = await api.get(finalUrl);
      const data: INotices[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchNoticesListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchNoticesListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertNoticesAysnc =
  (
    notices: INotices,
    file: any | null,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const asPayload = {};
      const path = await uploadFile(
        file,
        "NOTICE",
        notices.file_upload || "",
        asPayload
      );
      await api.post("/other/upsert-notice", { ...notices, file_upload: path });
      dispatch(
        showMessage({
          type: "success",
          message: "Notice saved succesfully!",
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_NOTICES_STATE = "CLEAR_NOTICES_STATE";

export const clearNoticesState = () => action(CLEAR_NOTICES_STATE);
